export default {"src":"/_next/static/media/yc.7408de57.svg","height":41,"width":210,"blurWidth":0,"blurHeight":0};